import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import common from "./modules/common";
import authcUser from "./modules/authcUser";
import vfAuthcUser from "./modules/vfAuthcUser";
import requestRegInfo from "./modules/requestRegInfo";
import terms from "./modules/terms";
import master from "./modules/master";
import mainteRequestListSearch from "./modules/mainteRequestListSearch";
import mainteAccountListSearch from "./modules/mainteAccountListSearch";
import mainteInquiryListSearch from "./modules/mainteInquiryListSearch";

import vfMaster from "./modules/vfMaster";
import vfAppInfo from "./modules/vfAppInfo";
import vfVerifyUserListSearch from "./modules/vfVerifyUserListSearch";
import vfReceiptAppListSearch from "./modules/vfReceiptAppListSearch";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        common,
        authcUser,
        master,
        requestRegInfo,
        terms,
        mainteRequestListSearch,
        mainteAccountListSearch,
        mainteInquiryListSearch,

        vfAuthcUser,
        vfMaster,
        vfAppInfo,
        vfVerifyUserListSearch,
        vfReceiptAppListSearch
    }
});
